export default __webpack_public_path__ + "static/people-holding-hands-393ef20b74ddc1fe6e8fe5f3d444d3f0.jpg";